import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearLeaguesSuspensions } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "@/tanstackQuery/queries/leaguesNew";
import type {
  ClearLeagueSuspensionsParams,
  LeagueSuspensionsEditorResponse,
} from "@/types/ApiResponses/League";

export const useClearLeaguesSuspensions = (targetUsername?: string) => {
  const queryClient = useQueryClient();
  const queryKey = [LeaguesNewQueryKeys.LeaguesSuspensions, targetUsername];

  return useMutation({
    mutationFn: (params: ClearLeagueSuspensionsParams) =>
      clearLeaguesSuspensions(params),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey, exact: true });

      const previousData =
        queryClient.getQueryData<LeagueSuspensionsEditorResponse>(queryKey);

      if (previousData) {
        queryClient.setQueryData<LeagueSuspensionsEditorResponse>(queryKey, {
          ...previousData,
          suspensions: {},
        });
      }

      return { previousData };
    },
    onError: (_err, _variable, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey, exact: true });
    },
  });
};
